import React, { ReactNode } from 'react'
import styled from 'styled-components'
import Box from 'shared/components/Box'
import TooltipIcon from 'assets/icons/TooltipIcon'
import { Tooltip, TooltipReference, TooltipArrow, useTooltipState } from 'reakit/Tooltip'

type CustomTooltipProps = {
  icon?: ReactNode
  title: string
  fill?: string
  width?: string
  height?: string
  toopTipMaxWidth?: string
  placement?:
    | 'auto-start'
    | 'auto'
    | 'auto-end'
    | 'top-start'
    | 'top'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start'
  className?: string
}

export function CustomTooltip(props: CustomTooltipProps) {
  const {
    icon,
    title = '',
    fill = '',
    width = '',
    height = '',
    toopTipMaxWidth = '250px',
    className = '',
    placement = 'top',
  } = props
  const tooltip = useTooltipState({ animated: 250, placement })

  return (
    <Box className={className}>
      <TooltipReference {...tooltip} as={SectionIcon}>
        {icon && typeof icon !== 'string' && icon}
        {icon && typeof icon === 'string' && <img src={icon} />}
        {!icon && <TooltipIcon width={width || '25'} height={height || '24'} fill={fill || '#1573FF'} />}
      </TooltipReference>

      <Tooltip {...tooltip} style={{ background: 'none', padding: 0 }}>
        <StyledTooltipMessageContainer maxWidth={toopTipMaxWidth} className="styled-tooltip">
          <TooltipArrow {...tooltip} />
          {title}
        </StyledTooltipMessageContainer>
      </Tooltip>
    </Box>
  )
}

const StyledTooltipMessageContainer = styled.div<{ maxWidth?: string }>`
  background-color: rgba(33, 33, 33, 0.9);
  color: white;
  padding: 10px;
  border-radius: 4px;
  max-width: 250px;
  ${({ maxWidth }) => `${maxWidth ? `max-width: ${maxWidth};` : 'max-width: 250px;'}`}
  transition: opacity 150ms ease-in-out, transform 150ms ease-in-out;
  opacity: 0;
  transform-origin: top center;
  transform: translate3d(0, -5px, 0);
  [data-enter] & {
    opacity: 1;
    transform: translate3d(0, 1px, 0);
  }
`

const SectionIcon = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
export default CustomTooltip
